import React from 'react';
import styles from './FeatureCard.module.css';
import Icon from '../Icon/Icon';

/**
 * @component FeatureCard
 * @description 기능 소개 카드 컴포넌트
 */
function FeatureCard({
  icon,
  title,
  subtitle,
  active = false,
  children,
  onClick,
  className = '',
  headerRight,
  badge,
}) {
  const cardClasses = [
    styles.featureCard,
    active && styles.active,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cardClasses} onClick={onClick}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          {icon && (
            <div className={styles.iconWrapper}>
              <Icon name={icon} size="24" />
              {badge != null && <span className={styles.badge}>{badge}</span>}
            </div>
          )}
          <div className={styles.headerText}>
            <h3 className={styles.title}>{title}</h3>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
        </div>
        {headerRight && <div className={styles.headerRight}>{headerRight}</div>}
      </div>
      {children && <div className={styles.content}>{children}</div>}
    </div>
  );
}

export default FeatureCard;
